import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || "development";
const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "0.1",
);

export function initSentry(): void {
  if (!SENTRY_DSN) {
    return;
  }

  const maskAllText = import.meta.env.VITE_SENTRY_REPLAY_MASK_TEXT !== "false";
  const blockAllMedia = import.meta.env.VITE_SENTRY_REPLAY_BLOCK_MEDIA !== "false";

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText,
        blockAllMedia,
      }),
    ],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function setSentryUser(userId: string, email?: string, orgId?: string): void {
  Sentry.setUser({
    id: userId,
    email,
    ...(orgId && { orgId }),
  });
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}

export { Sentry };
